import React from 'react';

export interface TabDef {
    key: string;
    label: string;
}

interface Props {
    tabs: TabDef[];
    active: string;
    onChange: (key: string) => void;
}

const TabBar: React.FC<Props> = ({ tabs, active, onChange }) => (
    <div className="border-b border-gray-200">
        <nav className="flex gap-6" aria-label="Tabs">
            {tabs.map((tab) => {
                const isActive = tab.key === active;
                return (
                    <button
                        key={tab.key}
                        onClick={() => onChange(tab.key)}
                        className={`pb-2.5 px-1 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap ${isActive
                            ? 'border-black text-gray-900'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </nav>
    </div>
);

export default TabBar;
